export type { GetRootCommandFn, CommandServices } from './general.js';
export type { GetAstroRootCommandFn, AstroCommandServices } from './astro.js';

export const NO_TTY_JSON_OUTPUT_OPTION = '--json';
